import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Hidden, IconButton, Drawer } from "@mui/material";
import { MenuSharp } from "@mui/icons-material";
import MenuList from "./MenuList";

const SidebarMobileDrawer = () => {
  const location = useLocation();

  const [isShow, setIsShow] = useState(false);

  const handleClick = () => {
    setIsShow(!isShow);
  };

  useEffect(() => {
    // Close drawer when router is changed
    setIsShow(false);
  }, [location]);

  return (
    <Hidden mdUp>
      <IconButton onClick={handleClick} color="inherit" edge="start">
        <MenuSharp />
      </IconButton>

      <Drawer open={isShow} onClose={() => setIsShow(false)}>
        <MenuList />
      </Drawer>
    </Hidden>
  );
};
export default SidebarMobileDrawer;
